export const LETRAS = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ'];

export const CLAVES_COLUMNAS = [
  { clave: 'fullName', validacion: 'alfabetica' },
  { clave: 'ownKey', validacion: 'alfanumerica' },
  { clave: 'age', validacion: 'alfanumerica' },
  { clave: 'surveyKey', validacion: 'alfanumerica' },
  { clave: 'email', validacion: 'email' },
  { clave: 'bossName', validacion: 'alfanumerica' },
  { clave: 'bossKey', validacion: 'alfanumerica' },
  { clave: 'country', validacion: 'alfabetica' },
  { clave: 'location', validacion: 'alfanumerica' },
  { clave: 'geo_1', validacion: 'alfanumerica' },
  { clave: 'geo_2', validacion: 'alfanumerica' },
  { clave: 'geo_3', validacion: 'alfanumerica' },
  { clave: 'geo_4', validacion: 'alfanumerica' },
  { clave: 'geo_5', validacion: 'alfanumerica' },
  { clave: 'geo_6', validacion: 'alfanumerica' },
  { clave: 'geo_7', validacion: 'alfanumerica' },
  { clave: 'geo_8', validacion: 'alfanumerica' },
  { clave: 'geo_9', validacion: 'alfanumerica' },
  { clave: 'geo_10', validacion: 'alfanumerica' },
  { clave: 'structure_1', validacion: 'alfanumerica' },
  { clave: 'structure_2', validacion: 'alfanumerica' },
  { clave: 'structure_3', validacion: 'alfanumerica' },
  { clave: 'structure_4', validacion: 'alfanumerica' },
  { clave: 'structure_5', validacion: 'alfanumerica' },
  { clave: 'structure_6', validacion: 'alfanumerica' },
  { clave: 'structure_7', validacion: 'alfanumerica' },
  { clave: 'structure_8', validacion: 'alfanumerica' },
  { clave: 'structure_9', validacion: 'alfanumerica' },
  { clave: 'structure_10', validacion: 'alfanumerica' },
  { clave: 'area', validacion: 'alfanumerica' },
  { clave: 'bUnit', validacion: 'alfanumerica' },
  { clave: 'enterDate', validacion: 'alfanumerica' },
  { clave: 'antiquity', validacion: 'alfanumerica' },
  { clave: 'antiquityUS', validacion: 'alfanumerica' },
  { clave: 'generation', validacion: 'alfanumerica' },
  { clave: 'generationUS', validacion: 'alfanumerica' },
  { clave: 'ageUS', validacion: 'alfanumerica' },
  { clave: 'charge', validacion: 'alfanumerica' },
  { clave: 'homologado', validacion: 'alfabetica' },
  { clave: 'homologadoUS', validacion: 'alfanumerica' },
  { clave: 'gender', validacion: 'alfabetica' },
  { clave: 'genderType', validacion: 'alfanumerica' },
  { clave: 'typeofwork', validacion: 'alfabetica' },
  { clave: 'workCondition', validacion: 'alfabetica' },
  { clave: 'academico', validacion: 'alfabetica' },
  { clave: 'contratacion', validacion: 'alfanumerica' },
  { clave: 'situacionUS', validacion: 'alfanumerica' },
  { clave: 'personal', validacion: 'alfabetica' },
  { clave: 'jornada', validacion: 'alfanumerica' },
  { clave: 'rotacion', validacion: 'alfabetica' },
  { clave: 'phone', validacion: 'numerica' },
  { clave: 'extension', validacion: 'numerica' },
  { clave: 'cellphone', validacion: 'numerica' },
  { clave: 'native', validacion: 'alfabetica' },
  { clave: 'answer', validacion: 'alfabetica' },
  { clave: 'other_1', validacion: 'alfanumerica' },
  { clave: 'other_2', validacion: 'alfanumerica' },
  { clave: 'other_3', validacion: 'alfanumerica' },
  { clave: 'other_4', validacion: 'alfanumerica' },
  { clave: 'other_5', validacion: 'alfanumerica' },
  { clave: 'other_6', validacion: 'alfanumerica' },
  { clave: 'other_7', validacion: 'alfanumerica' },
  { clave: 'other_8', validacion: 'alfanumerica' },
  { clave: 'other_9', validacion: 'alfanumerica' },
  { clave: 'other_10', validacion: 'alfanumerica' },
];

export const COLUMNAS_OBLIGATORIAS = [
  'fullName',
  'ownKey',
  'email',
  'phone',
  'extension',
  'cellphone',
  'country',
  'location',
  'area',
  'bossKey',
  'native',
  'charge',
  'answer',
  'age',
  'gender',
  'typeofwork',
  'workCondition',
  'enterDate',
  'antiquity',
  'surveyKey',
  'bossName',
  'generation'
];
export const COLUMNAS_OBLIGATORIAS_HK = [
  'fullName',
  'ownKey',
  'email',
  'location',
  'area',
  'homologado',
  'gender',
  'typeofwork',
  'workCondition',
  'academico',
  'native',
  'answer',
];
export const COLUMNAS_OBLIGATORIAS_TK = [
  'fullName',
  'ownKey',
  'email',
  'bossName',
  'bossKey',
  'country',
  'location',
  'native',
  'answer',
];
export const COLUMNAS_OBLIGATORIAS_CAYC = [
  'fullName',
  'ownKey',
  'age',
  'surveyKey',
  'email',
  'country',
  'location',
  'area',
  'enterDate',
  'antiquity',
  'generation',
  'charge',
  'homologado',
  'gender',
  'workCondition',
  'phone',
  'answer'
];
export const COLUMNAS_DEMOGRAFICOS = [
  'age',
  'gender',
  'typeofwork',
  'workCondition',
  'antiquity'
];
export const COLUMNAS_NO_REPETIR = [
  'ownKey',
  'email',
  'surveyKey'
];
export const FORMATO_ADMITIDO = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.sheet.macroenabled.12',
];
export interface Colaborador {
  _id?: string,
  productoId?: string,
  fullName?: string,
  ownKey?: string,
  email?: string,
  phone?: string,
  extension?: string,
  cellphone?: string,
  country?: string,
  location?: string,
  area?: string,
  bossKey?: string,
  native?: string,
  charge?: string,
  answer?: string,
  age?: string,
  gender?: string,
  typeofwork?: string,
  workCondition?: string,
  antiquity?: string,
  geo_1?: string,
  geo_2?: string,
  geo_3?: string,
  geo_4?: string,
  geo_5?: string,
  structure_1?: string,
  structure_2?: string,
  structure_3?: string,
  structure_4?: string,
  structure_5?: string,
  structure_6?: string,
  structure_7?: string,
  structure_8?: string,
  structure_9?: string,
  structure_10?: string,
  homologado?: string,
  academico?: string,
  contratacion?: string,
  personal?: string,
  jornada?: string,
  rotacion?: string,
  surveyKey?: string,
  bossName?: string,
  generation?: string,
  enterDate?:string,
  antiquityUS?: string,
  generationUS?: string,
  ageUS?: string,
  homologadoUS?: string,
  situacionUS?: string,
  bUnit?: string,
  geo_6?: string,
  geo_7?: string,
  geo_8?: string,
  geo_9?: string,
  geo_10?: string,
  genderType?: string,
  other_1?: string,
  other_2?: string,
  other_3?: string,
  other_4?: string,
  other_5?: string,
  other_6?: string,
  other_7?: string,
  other_8?: string,
  other_9?: string,
  other_10?: string,
}
export interface errorEncontrado{
  numeroFila:number,
  datos: any,
  listaErrores: listaErrores[]
}
export interface listaErrores{
  numeroColumna: string,
  columna: string,
  dato: any,
  tipoError: string
}
////respuesta al guardar bd colabs
export interface respuestaGuardaBD{
  colaboradores: number,
  fechaRegistro: string,
  message: string
}
////respuesta getfast
export interface getBDFast{
  message: string,
  numeroColaboradores: number,
  fecha: string
}
////respuesta getfull
export interface getBDFull{
  message: string,
  bdcolaboradores: Colaborador[],
  columnas: Colaborador
}
////respuesta elimina bd
export interface respuestaEliminaBD{
  fecha: string,
  message: string,
  respuesta: number
}
